
import { WithId, Esportone, StructuredEsportone, useSelectorRefresh, useFiltered } from 'django-rest-react'
import { Region, Country, Scuola, City } from '../api/types';


export enum Reverse {
  Regione = "regioni",
  Country = "countries",
  City = "cities",
  Scuola = "scuola",
}

type AppState = any;

export const regione_all = new Esportone<Region>(
  "REGIONE", () => "/api/iscrizione/region/", (state: AppState) => state.regioni);
export const country_all = new Esportone<Country>(
  "COUNTRY", () => "/api/iscrizione/country/", (state: AppState) => state.countries);
export const city_all = new StructuredEsportone<City>(
  "CITY", () => "/api/iscrizione/city/", (state: AppState) => state.cities);
export const scuola_all = new StructuredEsportone<Scuola>(
  "SCUOLA", () => "/api/iscrizione/scuola/", (state: AppState) => state.scuola);


interface ReverseMap {
  [key: string]: Esportone<WithId> | StructuredEsportone<WithId>
}

export const reducers_map: ReverseMap = {
  [Reverse.Regione]: regione_all,
  [Reverse.Country]: country_all,
  [Reverse.City]: city_all,
  [Reverse.Scuola]: scuola_all,
}


export const useRegione: (props: any) => Region[] = props => useSelectorRefresh(props, Reverse.Regione)
export const useCountry: (props: any) => Country[] = props => useSelectorRefresh(props, Reverse.Country)


let reducers_veri: ReverseMap = {};
Object.keys(reducers_map).forEach(key => {
  reducers_veri[key] = reducers_map[key].objectReducer.bind(reducers_map[key]);
});

export { reducers_veri };
